import { render, staticRenderFns } from "./ve.vue?vue&type=template&id=50c4be00"
import script from "./ve.vue?vue&type=script&lang=js"
export * from "./ve.vue?vue&type=script&lang=js"
import style0 from "./ve.vue?vue&type=style&index=0&id=50c4be00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports